
import { call, put, takeEvery } from 'redux-saga/effects'

import { createActionTypes } from '../../common/client/sagas/common';
import { ERROR_CLEAR_ACTION_TYPE, ERROR_CREATE_ACTION_TYPE } from '../../common/client/sagas/operationStatus';
import getPromiseCallback from '../../common/client/utils/getPromiseCallback';
import ErrorHttp from '../../common/client/utils/ErrorHttp';

import { SET_PROJECT } from './setProject';

export const GET_PROJECT_ACTION_TYPE = createActionTypes('project/GET_PROJECT');

export default function getActions(dispatch) {
    return {
        getProject: (token, project) => dispatch({
            type: GET_PROJECT_ACTION_TYPE.DEFAULT,
            project,
            token
        })
   }
}

function getProject(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callGet({
            module: 'project',
            name: 'getProject',
            params: [
                ['project', action.project],
                ['serverApiUrl', serverApi.getApiBaseUrl()],
                ['debug', (action.debug === true)]
            ],
            token: action.token,
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: 'project.content'
                }
            )
        });
    });
}

function* workGetProject(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        const project = yield call(getProject, options.serverApi, action);
        yield put({type: GET_PROJECT_ACTION_TYPE.SUCCESS, project: project});
        yield put({type: SET_PROJECT, project: project});
    } catch (error) {
        if (error instanceof ErrorHttp) {
            yield put({type: GET_PROJECT_ACTION_TYPE.FAILED, error, httpStatus: error.status});
        } else {
            yield put({type: GET_PROJECT_ACTION_TYPE.FAILED, error});
        }
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

export function* watchGetProject(options) {
    yield takeEvery(GET_PROJECT_ACTION_TYPE.DEFAULT, workGetProject, options)
}
